import api from '../../services/api';
import {
  GET_CHIT_GROUPS_REQUEST,
  GET_CHIT_GROUPS_SUCCESS,
  GET_CHIT_GROUPS_FAILURE,
  CREATE_CHIT_GROUP_REQUEST,
  CREATE_CHIT_GROUP_SUCCESS,
  CREATE_CHIT_GROUP_FAILURE,
  GET_CUSTOMER_CHITS_REQUEST,
  GET_CUSTOMER_CHITS_SUCCESS,
  GET_CUSTOMER_CHITS_FAILURE,
  CREATE_CUSTOMER_CHIT_REQUEST,
  CREATE_CUSTOMER_CHIT_SUCCESS,
  CREATE_CUSTOMER_CHIT_FAILURE,
  MAKE_CHIT_PAYMENT_REQUEST,
  MAKE_CHIT_PAYMENT_SUCCESS,
  MAKE_CHIT_PAYMENT_FAILURE,
  GET_CLOSED_CHITS_REQUEST,
  GET_CLOSED_CHITS_SUCCESS,
  GET_CLOSED_CHITS_FAILURE,
  CLOSE_CHIT_EARLY_REQUEST,
  CLOSE_CHIT_EARLY_SUCCESS,
  CLOSE_CHIT_EARLY_FAILURE,
  GET_CHIT_HISTORY_REQUEST,
  GET_CHIT_HISTORY_SUCCESS,
  GET_CHIT_HISTORY_FAILURE,
  GET_CHIT_PAYMENTS_REQUEST,
  GET_CHIT_PAYMENTS_SUCCESS,
  GET_CHIT_PAYMENTS_FAILURE
} from '../types';

// Chit Groups Actions
export const getChitGroups = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_CHIT_GROUPS_REQUEST });
    
    const response = await api.get('/chits/groups', { params });
    
    dispatch({
      type: GET_CHIT_GROUPS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_CHIT_GROUPS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch chit groups'
    });
  }
};

export const createChitGroup = (chitGroupData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CHIT_GROUP_REQUEST });
    
    const response = await api.post('/chits/groups', chitGroupData);
    
    dispatch({
      type: CREATE_CHIT_GROUP_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_CHIT_GROUP_FAILURE,
      payload: error.response?.data?.message || 'Failed to create chit group'
    });
    throw error;
  }
};

// Customer Chits Actions
export const getCustomerChits = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_CHITS_REQUEST });
    
    const response = await api.get('/chits/customer-chits', { params });
    
    dispatch({
      type: GET_CUSTOMER_CHITS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_CUSTOMER_CHITS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch customer chits'
    });
  }
};

export const createCustomerChit = (chitData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CUSTOMER_CHIT_REQUEST });
    
    const response = await api.post('/chits/customer-chits', chitData);
    
    dispatch({
      type: CREATE_CUSTOMER_CHIT_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_CUSTOMER_CHIT_FAILURE,
      payload: error.response?.data?.message || 'Failed to create customer chit'
    });
    throw error;
  }
};

// Chit Payments Actions
export const makeChitPayment = (paymentData) => async (dispatch) => {
  try {
    dispatch({ type: MAKE_CHIT_PAYMENT_REQUEST });
    
    const response = await api.post('/chits/payments', paymentData);
    
    dispatch({
      type: MAKE_CHIT_PAYMENT_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: MAKE_CHIT_PAYMENT_FAILURE,
      payload: error.response?.data?.message || 'Failed to record payment'
    });
    throw error;
  }
};

// Closed Chits Actions (for billing)
export const getClosedChitsForCustomer = (customerId) => async (dispatch) => {
  try {
    dispatch({ type: GET_CLOSED_CHITS_REQUEST });
    
    const response = await api.get(`/chits/closed-chits/${customerId}`);
    
    dispatch({
      type: GET_CLOSED_CHITS_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_CLOSED_CHITS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch closed chits'
    });
    throw error;
  }
};

// Close Chit Early
export const closeChitEarly = (chitId, closureData) => async (dispatch) => {
  try {
    dispatch({ type: CLOSE_CHIT_EARLY_REQUEST });
    
    const response = await api.post('/chits/close-early', {
      customer_chit_id: chitId,
      ...closureData
    });
    
    dispatch({
      type: CLOSE_CHIT_EARLY_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CLOSE_CHIT_EARLY_FAILURE,
      payload: error.response?.data?.message || 'Failed to close chit'
    });
    throw error;
  }
};

// Chit History Actions
export const getChitHistory = (customerChitId, params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_CHIT_HISTORY_REQUEST });
    
    const response = await api.get(`/chits/history/${customerChitId}`, { params });
    
    dispatch({
      type: GET_CHIT_HISTORY_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_CHIT_HISTORY_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch chit history'
    });
    throw error;
  }
};

// Chit Payments Actions
export const getChitPayments = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_CHIT_PAYMENTS_REQUEST });
    
    console.log('=== CHIT PAYMENTS ACTION DEBUG ===');
    console.log('Making API call to /chits/payments with params:', params);
    
    const response = await api.get('/chits/payments', { params });
    
    console.log('API response:', response.data);
    console.log('Response data:', response.data.data);
    console.log('Response data length:', response.data.data?.length);
    console.log('===================================');
    
    dispatch({
      type: GET_CHIT_PAYMENTS_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_CHIT_PAYMENTS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch chit payments'
    });
    throw error;
  }
};
